import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ajax from "@/lib/ajax";
import Util from "@/lib/util";
import appconst from "@/lib/appconst";
import Oidc from "oidc-client";

export interface IUserState {
  application: any;
  user: any;
  tenant: any;
  isVocationalSchool: boolean; // 是否为职校
}

@Module({ dynamic: true, store, name: "user" })
class User extends VuexModule implements IUserState {
  public application: any = {};
  public user: any = {};
  public tenant: any = {};
  public isVocationalSchool: boolean = false; // 是否为职校

  mgr: Oidc.UserManager;

  @Mutation
  private SET_USER(user: any) {
    this.user = user;
  }

  @Mutation
  private SET_APPLICATION(application: any) {
    this.application = application;
  }

  @Mutation
  private SET_TENANT(tenant: any) {
    this.tenant = tenant;
  }

  @Action
  public async RedirectToLogin() {
    this.mgr.signinRedirect();
  }

  @Action
  public async Login() {
    const userInfo = await this.mgr.signinRedirectCallback();

    var tokenExpireDate = undefined;

    Util.abp.auth.setToken(userInfo.access_token, tokenExpireDate);
    Util.abp.utils.setCookieValue(
      appconst.authorization.encrptedAuthTokenName,
      userInfo.access_token,
      tokenExpireDate,
      Util.abp.appPath
    );
  }

  @Action
  public ResetToken() {
    Util.abp.auth.setToken("", null);
  }

  @Action
  public async Init() {
    this.mgr = new Oidc.UserManager({
      authority: appconst.idServerUrl,
      client_id: "admin",
      redirect_uri: appconst.appBaseUrl + "#/account/redirect#",
      response_type: "id_token token",
      scope: "openid profile user-api sysadmin-api",
      post_logout_redirect_uri: appconst.appBaseUrl + "#/account/logout"
    });

    let rep = (await ajax.get(
      "sysadmin/api/services/app/Session/GetCurrentLoginInformations",
      {
        headers: {
          "Abp.TenantId": Util.abp.multiTenancy.getTenantIdCookie()
        }
      }
    )) as any;

    this.SET_APPLICATION(rep.application);
    console.log(rep)
    this.SET_USER(rep.user);
    this.SET_TENANT(rep.tenant);
  }

  @Action
  public async LogOut() {
    this.mgr.signoutRedirect();
    this.ResetToken();
  }
}

export const UserModule = getModule(User);
